import Comunicado from "../../assets/images/comunicado.webp";
import Modal from "react-bootstrap/Modal";
import "./WarningModal.css";

function WarningModal(props) {
  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      aria-label="warning-modal"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <img
          src={Comunicado}
          alt="Comunicado"
          className="warning-content-img"
          fetchpriority="high"
        />
      </Modal.Body>
    </Modal>
  );
}

export default WarningModal;
